import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import NvTabsTab from './nv-tabs/tab.js';
import NvTabsLink from './nv-tabs/link.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{!-- «UI nuova» tab list (NvTabs, spec docs/ui-nuova/components/tabs.md). Styles: app/styles/nuova/_tabs.scss. --}}\n{{#if this.isPage}}\n  <nav\n    class=\'nv-tablist {{this.sizeClass}} {{if @bleed \"nv-tablist--bleed\"}}\'\n    aria-label={{@label}}\n    data-ui-part=\'tabs\'\n    ...attributes\n    {{nv-tablist}}\n  >\n    {{yield (hash Link=this.Link)}}\n  </nav>\n{{else if this.overflowMenu}}\n  {{! @overflow=\'menu\': no sideways scroll, the tabs that do not fit go under «Altro ▾» (nv-tab-overflow) }}\n  <div\n    class=\'nv-tablist-wrap {{if @bleed \"nv-tablist--bleed\"}}\'\n    ...attributes\n    {{did-insert this.registerWrap}}\n    {{nv-tab-overflow this.setHidden}}\n  >\n    <div class=\'nv-tablist {{this.sizeClass}}\' role=\'tablist\' aria-label={{@label}} data-ui-part=\'tabs\' {{nv-tablist roving=true}}>\n      {{yield (hash Tab=this.Tab)}}\n    </div>\n    {{! always rendered: the modifier measures it; shown only by .nv-tablist-wrap--more (_tabs.scss) }}\n    <button\n      type=\'button\'\n      class=\'nv-tablist-tab nv-tablist-more\'\n      aria-haspopup=\'menu\'\n      aria-expanded={{if this.moreOpen \'true\' \'false\'}}\n      data-test-nv-tabs-more\n      {{on \'click\' this.toggleMore}}\n    >\n      <span class=\'nv-tablist-label\'><span class=\'nv-tablist-text\'>{{t \'nv.common.more\'}}</span></span>\n      <FaIcon @icon=\'chevron-down\' class=\'nv-tablist-icon\' aria-hidden=\'true\' />\n    </button>\n    {{#if (and this.moreOpen this.hidden.length)}}\n      <div class=\'nv-tablist-more-pane\' role=\'menu\' aria-label={{t \'nv.common.more\'}} data-test-nv-tabs-more-menu>\n        {{#each this.hidden as |tab|}}\n          <button\n            type=\'button\'\n            role=\'menuitem\'\n            class=\'nv-tablist-more-i\'\n            data-test-nv-tabs-more-item={{tab.id}}\n            {{on \'click\' (fn this.pickHidden tab.id)}}\n          >\n            <span class=\'nv-tablist-more-l\'>{{tab.label}}</span>\n            {{#if tab.count}}<span class=\'nv-tablist-count\'>{{tab.count}}</span>{{/if}}\n          </button>\n        {{/each}}\n      </div>\n    {{/if}}\n  </div>\n{{else}}\n  <div\n    class=\'nv-tablist {{this.sizeClass}} {{if @bleed \"nv-tablist--bleed\"}}\'\n    role=\'tablist\'\n    aria-label={{@label}}\n    data-ui-part=\'tabs\'\n    ...attributes\n    {{nv-tablist roving=true}}\n  >\n    {{yield (hash Tab=this.Tab)}}\n  </div>\n{{/if}}\n");

var _class, _descriptor, _descriptor2;
let NvTabs = (_class = class NvTabs extends Component {
  constructor(...args) {
    super(...args);
    this.Tab = NvTabsTab;
    this.Link = NvTabsLink;
    // ── @overflow='menu' ────────────────────────────────────────────────────────────────────────────────────────
    // the tabs that do not fit ([{ id, label, count }], from the nv-tab-overflow modifier) and the «Altro» pane
    _initializerDefineProperty(this, "hidden", _descriptor, this);
    _initializerDefineProperty(this, "moreOpen", _descriptor2, this);
    this._wrap = null;
    this._offOutside = null;
    this.setHidden = list => {
      this.hidden = list;
      if (!list.length) this.closeMore();
    };
  }
  get isPage() {
    return this.args.variant === 'page';
  }
  get sizeClass() {
    return this.args.size === 'sm' ? 'nv-tablist--sm' : 'nv-tablist--md';
  }
  get overflowMenu() {
    return this.args.overflow === 'menu' && !this.isPage;
  }
  registerWrap(element) {
    this._wrap = element;
  }
  toggleMore() {
    if (this.moreOpen) this.closeMore();else this.openMore();
  }
  openMore() {
    this.moreOpen = true;
    const onDown = event => {
      if (!this._wrap?.contains(event.target)) this.closeMore();
    };
    const onKey = event => {
      if (event.key === 'Escape') this.closeMore();
    };
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('keydown', onKey);
    this._offOutside = () => {
      document.removeEventListener('pointerdown', onDown, true);
      document.removeEventListener('keydown', onKey);
    };
  }
  closeMore() {
    this._offOutside?.();
    this._offOutside = null;
    if (this.moreOpen) this.moreOpen = false;
  }

  // a hidden tab is still the real button: activating it runs its own @onSelect and gates
  pickHidden(id) {
    this.closeMore();
    const tab = id ? document.getElementById(id) : null;
    tab?.click();
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this._offOutside?.();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "hidden", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "moreOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "registerWrap", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerWrap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMore", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeMore", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickHidden", [action], Object.getOwnPropertyDescriptor(_class.prototype, "pickHidden"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, NvTabs);

export { NvTabs as default };
//# sourceMappingURL=nv-tabs.js.map
